/**
 * FR8BOT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ChatMessageFileModel { 
    link?: string;
    name?: string;
    size?: number;
    document_type?: ChatMessageFileModel.DocumentTypeEnum;
}
export namespace ChatMessageFileModel {
    export const DocumentTypeEnum = {
        Img: 'IMG',
        Doc: 'DOC',
        Excel: 'EXCEL',
        Pdf: 'PDF',
        Gif: 'GIF',
        Zip: 'ZIP'
    } as const;
    export type DocumentTypeEnum = typeof DocumentTypeEnum[keyof typeof DocumentTypeEnum];
}


